import React, { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const InvoiceDetails = () => {
  const { Id } = useParams();
  const { data, error, isLoaded } = GetRequest(`/Account/GetInvoice/${Id}`);
  const invoiceRef = useRef();

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(",", "");
  };

  const downloadPDF = () => {
    const input = invoiceRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`Invoice_${data.result.invoiceNumber}.pdf`);
    });
  };

  if (error !== null) {
    return <Error data="Error loading invoice details" />;
  }
  if (!isLoaded) {
    return <Loading />;
  }

  return (
    <div className="container mt-4" ref={invoiceRef}>
      <div className="d-flex justify-content-between mb-3">
        <h5 className="text-blue">Invoice Details</h5>
        <div>
          {/* <button className="btn btn-primary me-2" onClick={downloadPDF}>Download PDF</button> */}
          <a
            href={`https://erelatevmdev.centralindia.cloudapp.azure.com/ReportsView/GenerateDownloadVoucher/${data.result.id}/invoice`}
            target="_blank"
          >
            <button type="button" className="btn btn-primary btn-block100">
              <i className="fa fa-download"></i> Download
            </button>{" "}
          </a>
          <Link to="/" className="btn btn-success me-2">
            Home
          </Link>
          <Link to="/AccountSummary" className="btn btn-success">
            Back
          </Link>
        </div>
      </div>

      <div className="card p-3 mb-4">
        <div className="row">
          <div className="col-md-6">
            <p>
              <b>Invoice Number:</b> {data.result.invoiceNumber}
            </p>
            <p>
              <b>Amount:</b> Rs {data.result.billableAmount ?? 0}
            </p>
            <p>
              <b>Total Invoice Amount:</b> Rs{" "}
              {data.result.totalInvoiceAmount ?? 0}
            </p>
            <p>
              <b>GST No:</b> {data.result.gstNo ?? "N/A"}
            </p>
          </div>
          <div className="col-md-6">
            <p>
              <b>Date:</b> {formatDate(data.result.invoiceDateTime)}
            </p>
            <p>
              <b>Tax:</b> Rs {data.result.tax ?? 0}
            </p>
            <p>
              <b>Other Charges:</b> Rs {data.result.otherCharges ?? 0}
            </p>
          </div>
        </div>
      </div>

      <div className="card p-3 mb-4">
        <h6 className="text-blue">Invoice Line Items</h6>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>No.</th>
              <th>Item Name</th>
              <th>Quantity In Primary Unit</th>
              <th>Unit Price</th>
              <th>Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {data.result.invoiceLineItemDTOs.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.itemName}</td>
                <td>{item.quantityInPrimaryUnit}</td>
                <td>Rs {item.unitPrice}</td>
                <td>Rs {item.totalCost}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="card p-3 mb-4">
            <h6 className="text-blue">Ship To Information</h6>
            <p>
              <b>Ship To Party Name:</b> {data.result.shipToPartyName ?? "N/A"}
            </p>
            <p>
              <b>Address:</b>{" "}
              {`${data.result.address1 ?? ""}, ${data.result.address2 ?? ""}, ${
                data.result.address3 ?? ""
              }`.trim()}
            </p>
            <p>
              <b>City:</b> {data.result.destination ?? "N/A"}
            </p>
            <p>
              <b>State:</b> {data.result.state} ({data.result.stateCode})
            </p>
            <p>
              <b>PIN Code:</b> {data.result.shipToPinCode}
            </p>
            <p>
              <b>GST No:</b> {data.result.shipToGstNo}
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card p-3 mb-4">
            <h6 className="text-blue">Contact Information</h6>
            <p>
              <b>Contact Person:</b> {data.result.contactPerson}
            </p>
            <p>
              <b>Mobile No:</b> {data.result.mobileNo}
            </p>
            <p>
              <b>Email:</b> {data.result.emailId || "N/A"}
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="card p-3 mb-4">
            <h6 className="text-blue">Dispatch Information</h6>
            <p>
              <b>Dispatch Document No:</b> {data.result.dispatchDocNo || "N/A"}
            </p>
            <p>
              <b>Dispatched Through:</b> {data.result.despatchThrough || "N/A"}
            </p>
            <p>
              <b>Destination:</b> {data.result.destination}
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card p-3 mb-4">
            <h6 className="text-blue">Vehicle & Logistics</h6>
            <p>
              <b>Vehicle No:</b> {data.result.vehicleNo || "N/A"}
            </p>
            <p>
              <b>Carrier/Agent:</b> {data.result.carrierNameAgent || "N/A"}
            </p>
            <p>
              <b>LR No:</b> {data.result.lrNo || "N/A"}
            </p>
            <p>
              <b>LR Date:</b>{" "}
              {data.result.lrDt ? formatDate(data.result.lrDt) : "N/A"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetails;
